export const initialState = {
  streamingTranscriptionEnabled: false,
  aiCoachingEnabled: false,
};

export default (state = initialState): typeof initialState => {
  return state;
};
